import { Col, Form, Input, Row } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserPersonalDataField } from '../../../../../contextRedux/User/UserModel';
import { RootState } from '../../../../../store';
import './UserPersonalDataTab.css';

const UserPersonalDataTab: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const userPersonalData = useSelector((state: RootState) => state.models.user.userPersonalData);

  useEffect(() => {
    form.setFieldsValue({
      userPersonalData,
    });
  }, [userPersonalData, form]);

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    if (changedValues.userPersonalData) {
      const updates = changedValues.userPersonalData;
      Object.entries(updates).forEach(([field, value]) => {
        dispatch(updateUserPersonalDataField({ field, value }));
      });
    }
  };

  return (
    <Form
      form={form}
      name='userForm'
      initialValues={{
        userPersonalData,
      }}
      onValuesChange={handleFieldChange}
      layout='vertical'
      style={{ margin: '20px 20px' }}
      className='userPersonalDataTab'
    >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Form.Item
            label='Nume'
            name={['userPersonalData', 'name']}
            rules={[{ required: true, message: 'Numele este necesar!' }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='CNP'
            name={['userPersonalData', 'cnp']}
            rules={[{ required: true, message: 'CNP-ul este necesar!' }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label='Seria' name={['userPersonalData', 'series']}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label='Nr. Seria' name={['userPersonalData', 'seriesNo']}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label='SPCLEP' name={['userPersonalData', 'spclep']}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Data Eliberarii'
            name={['userPersonalData', 'dateRelease']}
            rules={[{ required: true, message: 'Data eliberarii este necesara!' }]}
          >
            <Input type='date' />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Data Expirarii'
            name={['userPersonalData', 'dateExpiration']}
            rules={[{ required: true, message: 'Data expirarii este necesara!' }]}
          >
            <Input type='date' />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Data Nasterii'
            name={['userPersonalData', 'dateOfBirth']}
            rules={[{ required: true, message: 'Data nasterii este necesara!' }]}
          >
            <Input type='date' />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label='Adresa' name={['userPersonalData', 'address']}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item label='Judet' name={['userPersonalData', 'county']}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Email'
            name={['userPersonalData', 'email']}
            rules={[
              {
                type: 'email',
                message: 'Introduceti un email valid!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Telefon'
            name={['userPersonalData', 'phone']}
            rules={[
              {
                pattern: /^\+?[0-9]{7,15}$/,
                message: 'Introduceti un numar de telefon valid!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12}>
          <Form.Item
            label='Telefon Personal'
            name={['userPersonalData', 'phonePersonal']}
            rules={[
              {
                pattern: /^\+?[0-9]{7,15}$/,
                message: 'Introduceti un numar de telefon valid!',
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default UserPersonalDataTab;
